module.exports = __webpack_public_path__ + "static/media/40-14.b7c09626.mp3";